import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectLessonsLearnedComponent } from './project-lessons-learned.component';

const routes: Routes = [
  {
    path: '',
    component: ProjectLessonsLearnedComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectLessonsLearnedRoutingModule { }
